export const environment = {
  production: false,
  apiUrl: 'https://cafeteria-89h1.onrender.com',
};
